import React from "react";
import AuthService from "../../Services/AuthService";
import Authenticator from "./Authenticator";
import { Hub } from "aws-amplify";
import BaseAlphaUI from "../../BaseAlphaUI";

export type AuthenticatorConfig = {
  events?: {
    onLogin?: (() => Promise<void> | void)[];
    onLogout?: (() => Promise<void> | void)[];
  };
  header?: React.ReactNode;
};

// @ts-ignore
const withAuthentication = (
  Component: any,
  config: AuthenticatorConfig
): any => {
  class WrappedComponent extends React.Component {
    state = {
      isAuthenticated: null,
      initialState: undefined,
    };

    authService: AuthService;

    constructor(props: any) {
      super(props);

      this.authService = new AuthService();
      Hub.listen("auth", this.onAuthChange);
    }

    async componentDidMount(): Promise<void> {
      const isAuthenticated = await this.authService.isAuthenticated();
      if (window.location.pathname.toLowerCase() === "/checkhatlogin") {
        this.setState({
          isAuthenticated: false,
          initialState: "checkHatLogin",
        });
      } else {
        this.setState({
          isAuthenticated,
        });
      }
    }

    async componentDidUpdate(_prevProps: any, prevState: any): Promise<void> {
      if (prevState.isAuthenticated === false) {
        const isAuthenticated = await this.authService.isAuthenticated();
        this.setState({
          isAuthenticated,
        });
      }
    }

    onAuthChange = (capsule: any): void => {
      const { channel, payload } = capsule;
      if (channel === "auth") {
        if (payload.event === "signOut") {
          console.log("logging out");
          let events = [...BaseAlphaUI.getSignOutEvents()];
          if (config.events?.onLogout) {
            if (typeof config.events?.onLogout === "function") {
              // Single event callback
              events.push(config.events?.onLogout);
            } else {
              // Array of callbacks
              events = [...events, ...config.events?.onLogout];
            }
          }
          events.forEach((cb) => cb());
          window.location.href = "/";
        } else if (payload.event === "signIn") {
          this.setState({
            isAuthenticated: true,
          }, () => {
            if (config.events?.onLogin) {
              let events = [];
              if (typeof config.events?.onLogin === "function") {
                // Single event callback
                events.push(config.events?.onLogin);
              } else {
                // Array of callbacks
                events = [...events, ...config.events?.onLogin];
              }
              events.forEach((cb) => cb());
            }
          });
        }
      }
    };

    render(): React.ReactElement | React.ReactNode {
      if (this.state.isAuthenticated === null) {
        return <div>Loading ...</div>;
      }
      if (this.state.isAuthenticated) {
        return <Component {...this.props} />;
      }
      return <Authenticator initialState={this.state.initialState} header={config.header || null} />;
    }
  }
  return WrappedComponent;
};

export default withAuthentication;
